/* "saved gigs"
import React, {Fragment, useState, useRef, useContext} from 'react';
*/
import React, {useState, useContext, Fragment} from 'react';
import GigsList from './GigsList';
import {Box, Button, Heading, ResponsiveContext, Text} from 'grommet'
import { LinkPrevious, Medium } from 'grommet-icons'
import Filters from './Filters';
import Menu from './Menu';
import {LiveGigsContext} from "./LiveGigs";
import {SavedGigsContext} from "./SavedGigsContext";
import SavedGigs from "./SavedGigs";
import {View} from "./LiveGigs/View";

const Gigs = () => {

  const liveGigsContext = useContext(LiveGigsContext)
  const savedGigsContext = useContext(SavedGigsContext)

  const initialState = {
    gigsButtonLabel: "Show Saved",
    mode: 'results', // 'results' || 'filters'
    options: [],
    showSavedGigsOnly: false
  }

  const [state, setState] = useState(initialState)

    const handleToggleShowSavedGigsOnly = () => {
        if (state.showSavedGigsOnly) {
            setState({...state, gigsButtonLabel: "Show Saved", showSavedGigsOnly: !state.showSavedGigsOnly, options: [] })
        } else {
            setState({...state, gigsButtonLabel: "Show All", showSavedGigsOnly: !state.showSavedGigsOnly, options: [] })
        }
    }

    /* "saved gigs"
    let filtersRef;

    const setOptions = (options) => {
      setState({...state, options})
    }

    const clearFilter = (option) => {
      filtersRef.setDefaultValue(option.id)
    }
    */

    const changeSortState = (sortState) => {
      setState({...state, sortState})
    }

  const makeLoadingBox = () => (
    <Box fill='horizontal'>
      <Text size='large' color='brand'>Loading gigs...</Text>
    </Box>  // TODO: Better progress indicator
  )

    const makeMenu = () => (
        <Fragment>
            <Menu toggleSavedGigs={handleToggleShowSavedGigsOnly} options={state.options}/>
            {/*<Box background='light-3' fill='vertical' />*/}
        </Fragment>
    )

  const makeSavedGigs = () => (
      savedGigsContext.state.savedGigs
        ? <SavedGigs gigs={savedGigsContext.state.savedGigs}/>
        : makeLoadingBox()
  )

  const resolveLiveGigs = gigs => gigs.map(gig => {
    if (savedGigsContext.state.savedGigs)
      gig.isSaved = savedGigsContext.hasGig(gig.id)
    return gig
  })

  const makeLiveGigs = () => (
      liveGigsContext.state.liveGigsLoaded
        ? <View
              gigs={resolveLiveGigs(liveGigsContext.state.liveGigs)}
              reload={() => liveGigsContext.reload()}
              next={() => liveGigsContext.fetch()}
              hasMore={liveGigsContext.state.hasMore}
          />
        : makeLoadingBox()
  )

  const makeGigsList = () => (
      state.showSavedGigsOnly
        ? makeSavedGigs()
        : makeLiveGigs()
  )

    const mapSavedSearchOptions = srchs => srchs.map(s => ({ label: s.name, value: s.name }))

    const makeFilters = (filters, reset, search, setOption) => (
      !state.showSavedGigsOnly ?
          <Filters
              options={filters}
              reset={reset}
              search={search}
              setOption={setOption}
              addSearch={option => liveGigsContext.saveSearch(option)}
              deleteSearch={option => liveGigsContext.deleteSearch()}
              saveSearch={option => liveGigsContext.saveSearch()}
              loadSearch={option => liveGigsContext.loadSearch(option.value)}
              savedSearchOptions={mapSavedSearchOptions(liveGigsContext.state.searches)}
              savedSearchName={liveGigsContext.state.searchName}
              savedSearchLoading={liveGigsContext.state.loadingSearches}
          /> :
          null
  )

  const makeLargeContent = () => {
    const { state, reset, reload, setFilter } = liveGigsContext
    return (
        <Box direction='row-responsive' margin={{'horizontal': '20px', top: 'small'}}>
          <Box basis='3/4' margin={{ right: 'small'}}>
            {makeFilters(
                state.filters,
                reset,
                reload,
                setFilter
            )}
          </Box>
          <Box align='right'>
            {makeGigsList()}
            {makeMenu()}
          </Box>
        </Box>
    )
  }

  const makeResultsContent = () => (
      <Fragment>
        <Box margin={{ left: 'small' }}>
          <Button
              alignSelf='start'
              gap='xxsmall'
              icon={<LinkPrevious />}
              label="set filters"
              margin={{ vertical: 'medium' }}
              onClick={ () => { setState({ ...state, mode: 'filters' })} }
              plain={true}
          />
        </Box>
        <Box margin={{ horizontal: 'small' }}>
          <GigsList />
        </Box>
      </Fragment>
  )

  const reload = () => {
    liveGigsContext.reload()
    setState({...state, mode: 'results'})
  }

  const makeFiltersContent = () => (
    <Box margin={{ top: 'medium', horizontal: 'large' }}>
          {
            makeFilters(
              liveGigsContext.state.filters,
              liveGigsContext.reset,
              reload,
              liveGigsContext.setFilter
            )
          }
      </Box>
  )

  const makeModeContent = () => (
      state.mode === 'results'
        ? makeResultsContent()
        : makeFiltersContent()
  )

  const makeContent = size => (
      size === 'large'
        ? makeLargeContent()
        : makeModeContent()
  )

  return (
    <ResponsiveContext.Consumer>
      { size => makeContent(size) }
    </ResponsiveContext.Consumer>
  )
}

export { LiveGigsContext, LiveGigsProvider } from './LiveGigs'
export { SavedGigsContext, SavedGigsProvider } from './SavedGigsContext'
export default Gigs
